<script>

import { Overlay } from '../../'

export default {
    name: 'SMMA',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Smoothed Moving Average - Reduces lag by smoothing the SMA',
                preset: {
                    name: 'SMMA $length',
                    side: 'onchart',
                    settings: {
                        lineWidth: 0.75,
                        color: '#9c27b0'
                    }
                }
            }
        },
        use_for() { return ['SMMA'] },
        calc() {
            return {
                props: {
                    length: { def: 20, text: 'Length' }
                },
                conf: { renderer: 'Spline' },
                update: `
                    return rma(close, length)[0]
                `
            }
        }
    }
}
</script>
